import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [운영설정 > 기준정보편집] 이벤트/알람 기준 화면의 이벤트/알람 트리 데이터를 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getEventAlarmRuleTree() {
    return axios.get(`${baseUrl}/settings/oper/event-alarm-rule/get-event-alarm-rule-tree.do`);
  },

  /**
   * [운영설정 > 기준정보편집] 이벤트/알람 기준 화면의 이벤트/알람 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getEventAlarmRuleList(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/get-event-alarm-rule-list.do`, params);
  },

  /**
   * [운영설정 > 기준정보편집] 이벤트/알람 기준 화면의 이벤트/알람 목록을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateEventAlarmRuleList(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/update-event-alarm-rule-list.do`, params);
  },

  /**
   * [운영설정 > 기준정보편집] 이벤트/알람 기준 화면의 순차발송 템플릿 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRuleMgrAlarmRepeatList() {
    return axios.get(`${baseUrl}/settings/oper/event-alarm-rule/get-rule-mgr-alarm-repeat-list.do`);
  },

  /**
   * [운영설정 > 기준정보편집] 이벤트/알람 기준 화면의 이벤트/알람을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateEventAlarmRuleInfo(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/update-event-alarm-rule-info.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 기준 화면의 장비별 개별 이벤트/알람을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateIndividualEventAlarmRuleInfo(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/update-individual-event-alarm-rule-info.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 기준 화면의 장비별 개별 이벤트/알람 목록을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateIndividualEventAlarmRuleList(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/update-individual-event-alarm-rule-list.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서 선택된 자원의 개별 정책을 이벤트/알람 정책에 적용한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  applyIndividualEventAlarmRuleList(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/apply-individual-event-alarm-rule-list.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서 선택된 자원의 개별 정책 이벤트/알람 정책을 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteIndividualEventAlarmRuleList(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/delete-individual-event-alarm-rule-list.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서 선택된 자원의 개별 정책 이벤트/알람 정책을 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getCtrlScriptSetListByManagetypeId(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/get-ctrl-scrip-set-list-by-managetype-id.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서  선택한 eventAlarmRule 별 제어 스크립트 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getCtrlScriptSetListByEventAlarmRule(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/get-ctrl-scrip-set-list-by-event-alarm-rule.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서  선택한 script 추가시 중복여부를 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkRuleObjEventSetScriptValidation(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/check-rule-obj-event-set-script-validation.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서  선택한 script를 추가한다
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertRuleObjEventSetScript(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/insert-rule-obj-event-set-script.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서  선택한 script를 삭제한다
   * @author najongdang
   * @return {[type]}        [description]
   */
  DeleteRuleObjEventSetScript(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/delete-rule-obj-event-set-script.do`, params);
  },

  /**
   * [성능운영 > 장비] 햄버거 > 이벤트/알람 정책 화면에서  변경된 스크립트 목록을 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRuleObjEventSetScriptList(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/update-rule-obj-event-set-script-list.do`, params);
  },
  /**
   * 이벤트/알람 정책을 추가한다.
   * @param  {[type]} params [description]
   * @author jda
   */
  addEventAlarmRule(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/add-event-alarm-rule.do`, params);
  },
  /**
   * 이벤트/알람 정책을 삭제한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  deleteEventAlarmRule(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/delete-event-alarm-rule.do`, params);
  },
  /**
   * 이벤트/알람 정책 중복 여부를 확인한다.
   * true: 중복 / false : 중복 아님
   * @author Ju
   * @param  {String} ruleTmplId 중복 체크할 정책 아이디
   */
  checkDuplicateEventAlarmRule(ruleTmplId, managetypeId) {
    return axios.post(`${baseUrl}/settings/oper/rule/check-duplicate-collection-judgement-rule.do`, {
      ruleTmplId: `${managetypeId}_${ruleTmplId}`,
    });
  },
  /**
   * 이벤트/알람 정책 엑셀을 생성한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  createRuleEventAlarmExcel(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/create-rule-event-alarm-excel.do`, params);
  },
  updatePredictEventInfo(params) {
    return axios.post(`${baseUrl}/settings/oper/event-alarm-rule/update-predict-event-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/event-alarm-rule-settings.js